import cc from 'store/util/createReduxConstant';

export const FETCH_OPEN_OPPORTUNITY = cc('paperwork/FETCH_OPEN_OPPORTUNITY');
export const FETCH_OPEN_OPPORTUNITY_SUCCESS = cc('paperwork/FETCH_OPEN_OPPORTUNITY_SUCCESS');
export const FETCH_OPEN_OPPORTUNITY_FAIL = cc('paperwork/FETCH_OPEN_OPPORTUNITY_FAIL');
export const CLEAR_SF_OPPORTUNITY = cc('paperwork/CLEAR_SF_OPPORTUNITY');
